import { createAsyncThunk } from '@reduxjs/toolkit';
import { create } from 'superstruct';

import type { RootState } from '$store';
import {
  getMenu,
  getMenuForUpdate,
  getMenuPermissions,
  hydrateMenuDataWithPermissions,
} from '~services/api/calls/menu';
import { MenuElementsValidator } from '~services/api/validators/Menu';
import log from '~services/log';
import { MenuActions } from '~store/actions';
import { selectUserPermissions } from '~store/selectors';
import { MenuStatus } from '~store/slices/menu';

export const fetchMenuElements = createAsyncThunk<void, void, { state: RootState }>(
  'menu/fetch-elements',
  async (_, { dispatch, getState }) => {
    try {
      // Load menu (menu elements) from API and hydrate it with menu_permissions
      const responseMenu = await getMenu();
      const responseMenuPermissions = await getMenuPermissions();
      const hydratedMenu = hydrateMenuDataWithPermissions(responseMenu, responseMenuPermissions);
      const rootMenu = create(hydratedMenu, MenuElementsValidator);
      dispatch(MenuActions.rootMenuFetched(rootMenu));
      dispatch(MenuActions.setMenuStatus(MenuStatus.Idle));

      // Also load complete menu (with hidden files/folders) in background
      let responseMenuUnfiltered: MenuElementDto[] = [];
      const userPermissions = selectUserPermissions(getState());
      if (userPermissions.manageMenuElements || userPermissions.manageMenuGrants) {
        responseMenuUnfiltered = await getMenuForUpdate();
      }
      const hydratedMenuUnfiltered = hydrateMenuDataWithPermissions(responseMenuUnfiltered, responseMenuPermissions);
      const unfilteredMenu = create(hydratedMenuUnfiltered, MenuElementsValidator);
      dispatch(MenuActions.unfilteredMenuFetched(unfilteredMenu));
    } catch (e) {
      log('Error in fetchMenuElements thunk!', e, 'error');
    }
  },
);
